export * from "./HeroWithImage";
